import styled from "styled-components"

export const ContactFormStyled = styled.div`
  .form-content {
    padding: 46px 0 80px 0;
    h1 {
      font-size: 37px;
    }
    p {
      margin: 32px 0 32px;
      span {
        font-weight: 500;
      }
    }
  }
  .input-column,
  .button-column {
    padding: 0;
  }
  .button-column {
    padding-top: ${props => (props.careerView ? "20px" : "0")};
    width: 100%;
    p {
      font-weight: 300;
      font-size: 16px;
      margin: 0;
      padding-bottom: 0;
    }
  }
  label {
    width: 100%;
  }
  .bg-gray {
    background-color: #f1f1f1;
  }
  .container-fluid {
    padding: 0;
  }
  .file-input-wrapper {
    max-height: 90px;
    display: flex;
    padding-left: 17px;
    padding-top: 7px;
    /* background-color: white; */
    .icon {
      img {
        height: 24px;
      }
    }
    .file-input-box {
      width: 100%;
      font-family: "futura-pt", sans-serif !important;
    }
    .error-file {
      margin-top: -30px;
      height: 20px;
      font-family: "futura-pt", sans-serif !important;
      font-size: 16px;
      color: #e00000;
      position: absolute;
      bottom: 0;
      left: 58px;
      font-weight: 500;
    }
    label {
      padding-left: 15px;
      p {
        margin: 0;
        font-family: "futura-pt", sans-serif !important;
        font-size: 20px;
        font-weight: 500;
        cursor: pointer;
        padding: 0;
      }
      .file-name {
        font-size: 18px;
        font-weight: 400;
      }
      input {
        opacity: 0;
        margin: 0;
        max-height: 15px;
      }
    }
  }
  .checkbox-input-wrapper {
    > div {
      position: relative;
      min-height: 45px;
      padding-bottom: 12px;
      margin-bottom: 10px;
    }
    .error-message {
      position: absolute;
      bottom: 5px;
      color: #e00000;
      font-weight: 500;
      left: 24px;
    }
    label {
      display: flex;
      flex-wrap: nowrap;
      align-items: baseline;
      p {
        margin: 0 0 10px;
        font-size: 14px;
        /* width: 100%; */
      }
      input {
        margin: 0 10px 0 0;
        width: 60px;
        height: 14px;
      }
    }
  }
  .file-input {
    margin-bottom: 22px;
    border: none;
  }
  p.checkbox-name {
    margin: ${props => (props.careerView ? "0" : "15px 0 30px 0")};
    font-size: 16px;
    font-weight: 300;
    span {
      font-weight: 300;
      font-size: 12px;
    }
  }
  @media (min-width: 1200px) {
    .form-content {
      //padding-left: 80px;
      padding-top: 0;
      padding-right: 0;
      h1 {
        font-size: 48px;
        margin-bottom: 40px;
      }
      p {
        padding: 0;
        margin-bottom: 30px;
      }
      p.form-subtitle {
        font-size: 20px;
      }
      p.error-message {
        padding: 0 10px;
      }
    }
    .button-column {
      p {
        padding-top: 20px;
      }
    }
  }
  .form-container {
    padding-left: 0;
  }
`

export const InputStyled = styled.div`
  margin-bottom: 18px;
  input,
  textarea,
  select {
    width: 100%;
    border: none;
    padding: 15px 10px 15px 55px;
    outline: none;
    font-size: 20px;
    font-weight: 500;
    position: relative;
    border-radius: 4px;
    border: 2px solid transparent;
    color: #000;
    &::placeholder {
      color: #000;
      font-family: "futura-pt", sans-serif !important;
      font-weight: ${props => (props.textarea ? "300" : "inherit")};
    }
    &:focus {
      border: 2px solid #9ecd49;
    }
  }
  select {
    border: none;
    appearance: none;
    background-color: white;
    option {
      border: none;
    }
  }
  textarea {
    padding-left: ${props => (props.textarea ? "20px" : "")};
    border-radius: 0 0 4px 4px;
    &:focus {
      .textarea-head {
        border: 2px solid #9ecd49 !important;
      }
      //border-top: none;
    }
  }
  .icon-textarea {
    position: inherit !important;
    transform: none !important;
    padding: 25px 17px 0 17px;
  }
  .textarea-head {
    background-color: #fff;
    display: flex;
    flex-direction: row;
    border-radius: 4px 4px 0 0;
    border: 2px solid transparent;
    border-bottom: 1px solid #dadada;
    padding-bottom: 18px;
    p {
      margin: 0;
      color: #000;
    }
    p:nth-last-of-type(1) {
      padding: 0;
      font-weight: 300;
      font-size: 16px;
    }
    p:nth-last-of-type(2) {
      padding: 26px 0 11px 0;
      font-size: 20px;
      font-weight: 500;
      text-transform: none;
    }
  }
  .icon {
    position: absolute;
    left: 15px;
    top: 37%;
    transform: translateY(-50%);
    img {
      max-height: 24px;
    }
  }
  .error-message {
    position: absolute;
    bottom: -16px;
    margin: 0 10px;
    left: 47px;
    color: #e00000;
    z-index: 999;
    font-size: 16px;
    font-weight: 500;
    /* padding: 0 10px; */
    //text-align: center;
    /* background-color: aqua; */
    background: linear-gradient(to top, #f8f8f8 50%, #fff 50%);
    //&:after {
    //position: absolute;
    //top: 10px;
    //left: 0px;
    //content: '';
    //width: 100%;
    //height: 10px;
    //background-color: #f8f8f8;
    //background-color: green;/
    //}
  }
`

export const ModalStyled = styled.div`
  .modal.show .modal-dialog .modal-content {
    overflow: visible !important;
  }
  .modal-container {
    padding: 40px 20px 40px 20px;
    .icon {
      display: flex;
      justify-content: center;
      margin-bottom: 30px;
      img {
        height: 110px;
      }
    }
    .content {
      p {
        text-align: center;
        margin: 0;
      }
      p:nth-of-type(1) {
        font-weight: 600;
        font-size: 20px;
        margin-bottom: 15px;
        line-height: 24px;
      }
      p:nth-of-type(2) {
        text-align: center;
        font-size: 16px;
      }
    }
  }
`
